import { render, staticRenderFns } from "./PrivacyTerms.vue?vue&type=template&id=616dae1c&scoped=true&"
import script from "./PrivacyTerms.vue?vue&type=script&lang=js&"
export * from "./PrivacyTerms.vue?vue&type=script&lang=js&"
import style0 from "./PrivacyTerms.vue?vue&type=style&index=0&id=616dae1c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "616dae1c",
  null
  
)

export default component.exports